import React from "react";
import { resolveMediaUrl } from "../utils/mediaUrl";

const DEFAULT_TITLE = "We'll be back soon";
const DEFAULT_MESSAGE =
  "The website is currently undergoing maintenance. Please check back shortly.";

const MaintenancePage = ({ settings = {}, headerLogo = "" }) => {
  const title = (settings.title || "").trim() || DEFAULT_TITLE;
  const message = (settings.message || "").trim() || DEFAULT_MESSAGE;
  const imageSrc = resolveMediaUrl(settings.image);
  const logoSrc = resolveMediaUrl(headerLogo);

  return (
    <div className="min-h-screen bg-[#f4f1ea] text-slate-800">
      <div className="mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-6 py-12 text-center">
        {logoSrc ? (
          <img
            src={logoSrc}
            alt="Site logo"
            className="mb-8 h-16 w-auto object-contain"
          />
        ) : (
          <p className="mb-8 text-sm font-semibold uppercase tracking-[0.2em] text-[#38513b]">
            Veteran Airsoft
          </p>
        )}

        {imageSrc ? (
          <img
            src={imageSrc}
            alt=""
            className="mb-8 max-h-72 w-full max-w-xl rounded-2xl object-contain"
          />
        ) : null}

        <h1 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
          {title}
        </h1>
        <p className="mt-4 max-w-xl whitespace-pre-line text-base leading-7 text-slate-600 sm:text-lg">
          {message}
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
